import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-858">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-859">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-860">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-861" />
          <span data-id="element-862">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-863">
        <div className="text-center mb-12" data-id="element-864">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-865">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-866">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-867">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-868">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-869">
              <h2 className="text-xl font-bold text-white" data-id="element-870">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-871">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-872">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-873">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-874">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-875">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-876">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-877">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-878">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-879">
                      <span data-id="element-880">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-881" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-882">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-883">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-884">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-885">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-886" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-887">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-888">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-889">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-890">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-891" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-892">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-893">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-894">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-895">
              <h2 className="text-xl font-bold text-white" data-id="element-896">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-897">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-898">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-899">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-900">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-901">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-902">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-903">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-904">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-905">
                      <span data-id="element-906">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-907" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-908">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-909">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-910">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-911">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-912" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-913">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-914">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-915">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-916">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-917" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-918">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-919">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-920">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-921">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-922">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-923">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-924">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-925">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-926">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-927">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-928">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-929">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-930">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-931">
                      <span data-id="element-932">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-933" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-934">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-935">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-936">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-937">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-938" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-939">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-940">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-941">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-942">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-943" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-944">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-945">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-946">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-947">
              <h2 className="text-xl font-bold text-white" data-id="element-948">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-949">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-950">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-951">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-952">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-953">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-954">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-955">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-956">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-957">
                      <span data-id="element-958">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-959" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-960">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-961">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-962">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-963">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-964" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-965">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-966">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-967">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-968">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-969" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-970">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-971">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-972">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-973">
              <h2 className="text-xl font-bold text-white" data-id="element-974">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-975">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-976">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-977">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-978">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-979">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-980">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-981">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-982">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-983">
                      <span data-id="element-984">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-985" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-986">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-987">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-988">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-989">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-990" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-991">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-992">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-993">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-994">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-995" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-996">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-997">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-998">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-999">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-1000">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1001">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-1002">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1003">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-1004">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-1005">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-1006">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-1007">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-1008">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-1009">
                      <span data-id="element-1010">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-1011" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-1012">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-1013">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-1014">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-1015">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1016" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1017">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1018">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-1019">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-1020">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-1021" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1022">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1023">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}